// eslint-disable-next-line max-classes-per-file
import _ from "@lodash";
import { saveAs } from "file-saver";
import { openToast } from "app/store/trackingApp/toastSlice";
import store from "app/store";
import CryptoJS from "crypto-js";
import getEnv from "env";

const REACT_APP_VIATRACKING_KEY_DECRYPT = getEnv(
  "REACT_APP_VIATRACKING_KEY_DECRYPT"
);

class TrackingUtils {
  static filterArrayByString(mainArr, searchText) {
    if (searchText === "") {
      return mainArr;
    }

    searchText = searchText.toLowerCase();

    return mainArr.filter((itemObj) => this.searchInObj(itemObj, searchText));
  }

  static searchInObj(itemObj, searchText) {
    if (!itemObj) {
      return false;
    }

    const propArray = Object.keys(itemObj);

    for (let i = 0; i < propArray.length; i += 1) {
      const prop = propArray[i];
      const value = itemObj[prop];

      if (typeof value === "string") {
        if (this.searchInString(value, searchText)) {
          return true;
        }
      } else if (Array.isArray(value)) {
        if (this.searchInArray(value, searchText)) {
          return true;
        }
      }

      if (typeof value === "object") {
        if (this.searchInObj(value, searchText)) {
          return true;
        }
      }
    }
    return false;
  }

  static searchInArray(arr, searchText) {
    arr.forEach((value) => {
      if (typeof value === "string") {
        if (this.searchInString(value, searchText)) {
          return true;
        }
      }

      if (typeof value === "object") {
        if (this.searchInObj(value, searchText)) {
          return true;
        }
      }
      return false;
    });
    return false;
  }

  static searchInString(value, searchText) {
    return value.toLowerCase().includes(searchText);
  }

  static toggleInArray(item, array) {
    if (array.indexOf(item) === -1) {
      array.push(item);
    } else {
      array.splice(array.indexOf(item), 1);
    }
  }

  static setRoutes(config, defaultAuth) {
    let routes = [...config.routes];

    routes = routes.map((route) => {
      let auth =
        config.auth || config.auth === null ? config.auth : defaultAuth || null;
      auth = route.auth || route.auth === null ? route.auth : auth;
      const settings = _.merge({}, config.settings, route.settings);

      return {
        ...route,
        settings,
        auth,
      };
    });

    return [...routes];
  }

  static generateRoutesFromConfigs(configs: any[], defaultAuth?: undefined) {
    let allRoutes: any = [];
    configs.forEach((config: any) => {
      allRoutes = [...allRoutes, ...this.setRoutes(config, defaultAuth)];
    });
    return allRoutes;
  }

  static findById(obj, id) {
    let i;
    let childObj;
    let result;

    if (id === obj.id) {
      return obj;
    }

    for (i = 0; i < Object.keys(obj).length; i += 1) {
      childObj = obj[Object.keys(obj)[i]];

      if (typeof childObj === "object") {
        result = this.findById(childObj, id);
        if (result) {
          return result;
        }
      }
    }
    return false;
  }

  static getFlatNavigation(navigationItems, flatNavigation: any = []) {
    for (let i = 0; i < navigationItems.length; i += 1) {
      const navItem = navigationItems[i];

      if (navItem.type === "item") {
        flatNavigation.push({
          id: navItem.id,
          title: navItem.title,
          type: navItem.type,
          icon: navItem.icon || false,
          url: navItem.url,
          auth: navItem.auth || null,
        });
      }

      if (navItem.type === "collapse" || navItem.type === "group") {
        if (navItem.children) {
          this.getFlatNavigation(navItem.children, flatNavigation);
        }
      }
    }
    return flatNavigation;
  }

  static difference(object, base) {
    function changes(_object, _base) {
      return _.transform(_object, (result: any, value, key) => {
        if (!_.isEqual(value, _base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(_base[key])
              ? changes(value, _base[key])
              : value;
        }
      });
    }

    return changes(object, base);
  }

  static updateNavItem(nav, id, item) {
    return nav.map((_item) => {
      if (_item.id === id) {
        return _.merge({}, _item, item);
      }

      if (_item.children) {
        return _.merge({}, _item, {
          children: this.updateNavItem(_item.children, id, item),
        });
      }

      return _.merge({}, _item);
    });
  }

  static removeNavItem(nav, id) {
    return nav
      .map((_item) => {
        if (_item.id === id) {
          return null;
        }

        if (_item.children) {
          return _.merge({}, _.omit(_item, ["children"]), {
            children: this.removeNavItem(_item.children, id),
          });
        }

        return _.merge({}, _item);
      })
      .filter((s) => s);
  }

  static prependNavItem(nav, item, parentId) {
    if (!parentId) {
      return [item, ...nav];
    }

    return nav.map((_item) => {
      if (_item.id === parentId && _item.children) {
        return {
          _item,
          children: [item, ..._item.children],
        };
      }

      if (_item.children) {
        return _.merge({}, _item, {
          children: this.prependNavItem(_item.children, item, parentId),
        });
      }

      return _.merge({}, _item);
    });
  }

  static appendNavItem(nav, item, parentId) {
    if (!parentId) {
      return [...nav, item];
    }

    return nav.map((_item) => {
      if (_item.id === parentId && _item.children) {
        return {
          ..._item,
          children: [..._item.children, item],
        };
      }

      if (_item.children) {
        return _.merge({}, _item, {
          children: this.appendNavItem(_item.children, item, parentId),
        });
      }

      return _.merge({}, _item);
    });
  }

  static hasPermission(authArr, userRole) {
    /**
     * If auth array is not defined
     * Pass and allow
     */
    if (authArr === null || authArr === undefined) {
      return true;
    }
    if (authArr.length === 0) {
      /**
       * if auth array is empty means,
       * allow only user role is guest (null or empty[])
       */
      return !userRole || userRole.length === 0;
    }
    /**
     * Check if user has grants
     */
    /*
            Check if user role is array,
            */
    if (userRole && Array.isArray(userRole)) {
      return authArr.some((r) => userRole.indexOf(r) >= 0);
    }

    /*
            Check if user role is string,
            */
    return authArr.includes(userRole);
  }

  static filterRecursive(data, predicate) {
    // if no data is sent in, return null, otherwise transform the data
    return !data
      ? null
      : data.reduce((list, entry) => {
          let clone = null;
          if (predicate(entry)) {
            // if the object matches the filter, clone it as it is
            clone = { ...entry };
          }
          if (entry.children != null) {
            // if the object has childrens, filter the list of children
            const children = this.filterRecursive(entry.children, predicate);
            if (children.length > 0) {
              // if any of the children matches, clone the parent object, overwrite
              // the children list with the filtered list
              clone = { ...entry, children };
            }
          }

          // if there's a cloned object, push it to the output list
          clone && list.push(clone);
          return list;
        }, []);
  }

  static formatNumber = (number: number): string =>
    new Intl.NumberFormat("pt-BR").format(number);

  static formaCurrencyNumber = (number: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(number);
  };

  static percent = (val: number, total: number) => {
    if (val && total) {
      const x: number = val / total;
      const y: number = x * 100;
      return y.toFixed(2);
    }
    return 0;
  };

  static percentFormat = (num: any) =>
    Number(num / 100).toLocaleString([], {
      style: "percent",
      minimumFractionDigits: 2,
    });

  static buildQueryStringArray = (url, parametros) => {
    let primeiro = true;
    var newUrl = url;
    if (parametros) {
      Object.keys(parametros).forEach((item) => {
        if (parametros[item]) {
          if (
            typeof parametros[item] === "object" &&
            parametros[item].length > 0
          ) {
            parametros[item].forEach((param) => {
              if (param) {
                if (primeiro) {
                  newUrl += "?";
                } else {
                  newUrl += "&";
                }
                newUrl += item + "=" + param?.name?.replaceAll("+", "%2B");
                primeiro = false;
              }
            });
          } else {
            if (primeiro) {
              newUrl += "?";
            } else {
              newUrl += "&";
            }
            newUrl += item + "=" + parametros[item]?.replaceAll("&", "%26");
            primeiro = false;
          }
        }
      });
    }
    return newUrl;
  };

  static buildQueryString = (url, parametros) => {
    let primeiro = true;
    Object.keys(parametros).forEach((item) => {
      if (parametros[item] && parametros) {
        if (primeiro) {
          url += "?";
        } else {
          url += "&";
        }
        url += item + "=" + parametros[item];
        primeiro = false;
      }
    });
    return url;
  };

  static processQueryKeys = (queryKeys) => {
    let x = "";
    let primeiro = true;
    Object.keys(queryKeys).forEach((key) => {
      if (queryKeys[key]) {
        if (primeiro) {
          x += key;
        } else {
          x += ", " + key;
        }
        primeiro = false;
      }
    });
    return x;
  };

  static formatCNPJ = (cnpj: string | number) => {
    let newCnpj = String(cnpj);
    if (/^\d+$/.test(newCnpj)) {
      while (newCnpj.length < 14) {
        newCnpj = '0' + newCnpj;
      }
    }
    newCnpj = newCnpj.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})$/i,
      "$1.$2.$3/$4-$5"
    );
    return newCnpj;
  };

  static complementCNPJ = (cnpj: number = 0) => {
    let newCnpj = String(cnpj);
    while (newCnpj.length < 14) {
      newCnpj = 0 + newCnpj;
    }
    return newCnpj;
  };

  static formatCpfCnpj = (cpfCnpj: string | number) => {
    let raw = String(cpfCnpj ?? "")
      .replace(/[^A-Za-z0-9]/g, "")
      .toUpperCase();

    if (!raw) return "";

    const isNumeric = /^\d+$/.test(raw);

    if (isNumeric && raw.length <= 11) {
      while (raw.length < 11) raw = `0${raw}`;
      return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6, 9)}-${raw.slice(9, 11)}`;
    }

    if (isNumeric && raw.length < 14) {
      while (raw.length < 14) raw = `0${raw}`;
    }

    if (raw.length >= 14) {
      return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12, 14)}`;
    }

    return raw;
  };

  static sanitizeCnpjInput = (value: string | number | null | undefined) =>
    String(value ?? "")
      .replace(/[^A-Za-z0-9]/g, "")
      .toUpperCase()
      .slice(0, 14);

  static formatCnpjInput = (value: string | number | null | undefined) => {
    const raw = TrackingUtils.sanitizeCnpjInput(value);
    if (!raw) return "";

    let formatted = raw.slice(0, 2);
    if (raw.length > 2) formatted += `.${raw.slice(2, 5)}`;
    if (raw.length > 5) formatted += `.${raw.slice(5, 8)}`;
    if (raw.length > 8) formatted += `/${raw.slice(8, 12)}`;
    if (raw.length > 12) formatted += `-${raw.slice(12, 14)}`;
    return formatted;
  };

  static formatCEP = (str: string) => {
    var re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

    if (re.test(str)) {
      return str.replace(re, "$1.$2-$3");
    } else {
      return "";
    }
  };

  static formatSTDNumber = (str: string) => {
    var model = "00000000000";

    if (!str || str.length > 11) {
      return str;
    }

    return (
      model.substring(1, model.length + 1 - str.length) +
      str.substring(1 - str.length, str.length)
    );
  };

  static isUrlInChildren(parent, url) {
    if (!parent.children) {
      return false;
    }

    for (let i = 0; i < parent.children.length; i += 1) {
      if (parent.children[i].children) {
        if (this.isUrlInChildren(parent.children[i], url)) {
          return true;
        }
      }

      if (
        parent.children[i].path === url ||
        url.includes(parent.children[i].path)
      ) {
        return true;
      }
    }

    return false;
  }

  static needsToBeOpened(location, item) {
    return location && this.isUrlInChildren(item, location.pathname);
  }

  static sortAlpha = (a, b, property) => {
    if (a[property] && b[property]) {
      if (a[property] < b[property]) {
        return -1;
      }
      if (a[property] > b[property]) {
        return 1;
      }
    }
    return 0;
  };

  static parseMultiFieldFilter = (data: any[]) => {
    let newData: any[] = [];
    data.forEach((item: any) => {
      newData.push({
        name: item,
      });
    });
    return newData;
  };

  static createArrayObjectDynamicProp = (
    data: any[] = [],
    prop: string | number
  ) => {
    return data.map((item: any) => {
      return {
        [prop]: item,
      };
    });
  };

  static getLabelAutoComplete = (
    value: string | number,
    arr: any[] = [],
    itemProp: string,
    labelProp: string,
    concatProp?: string | number,
    characterConcat?: string
  ) => {
    const newArr = [...arr];
    const label = newArr.find(
      (item: { [x: string]: any }) => item[itemProp] === value
    );

    if (concatProp && label) {
      return characterConcat
        ? `${label[labelProp]} ${characterConcat} ${label[concatProp]}`
        : `${label[labelProp]} - ${label[concatProp]}`;
    }

    return label ? label[labelProp] : "";
  };

  static parseMultiValues = (data: any[], prop: any) => {
    let newData: any[] = [];
    data.forEach((item: any) => {
      newData.push(item[prop] ? item[prop] : item);
    });
    return newData;
  };

  static formatPhone = (phone: number | string | undefined) => {
    let newPhone =
      phone !== "undefined" || phone !== undefined ? String(phone).trim() : "";
    while (newPhone.length < 11) {
      newPhone = 0 + newPhone;
    }
    return newPhone;
  };

  static arrayToString = (separator: string, arr: string[] = []): string => {
    let parsedValue = "";
    if (arr?.length) parsedValue = arr.join(separator);
    return parsedValue;
  };

  static parseOnlyResultGetRequest = (result) => {
    const parsedOnlyItem = result.hasOwnProperty("items")
      ? result.items.length
        ? result.items[0]
        : null
      : null;

    const parsedOnlyMessage = result.hasOwnProperty("messages")
      ? result.messages.length
        ? result.messages[0]
        : null
      : null;

    return {
      item: parsedOnlyItem,
      message: parsedOnlyMessage,
    };
  };

  static parsingFieldsUncovered = (fields: any = []) => {
    let newFields: Array<{ nomeCampo: string; conteudoCampo: string }> = [];
    Object.keys(fields).forEach((keyField) => {
      newFields.push({ nomeCampo: keyField, conteudoCampo: fields[keyField] });
    });
    return newFields;
  };

  static hexSignatures = [
    {
      signature: "89504E",
      ext: "png",
    },
    {
      signature: "FFD8FF",
      ext: "jpg",
    },
  ];

  static verifyBase64 = (base64: string) => {
    let newBase64: string = "";
    if (base64.startsWith("http")) {
      return base64;
    } else if (!base64.startsWith("data:")) {
      const raw = window.atob(base64);
      let result = "";
      for (let i = 0; i < raw.length; i++) {
        const hexChar = raw.charCodeAt(i).toString(16);
        result += hexChar.length === 2 ? hexChar : "0" + hexChar;
      }
      const hex = result.toUpperCase();
      const hexMimify = hex.substr(0, 6);
      const res = this.hexSignatures.filter((x) => x.signature === hexMimify);
      if (res.length) {
        newBase64 = `data:image/${res[0].ext};base64,${base64}`;
        return newBase64;
      }
      return "";
    } else {
      return base64;
    }
  };

  static isPDF = (base64: string) => base64.startsWith("data:application/pdf");

  static downloadAtt = (url: string, fileName: string) => {
    if (url) {
      saveAs(this.verifyBase64(url), fileName || "Imagem do comprovante");
    } else {
      store.dispatch(
        openToast({
          severity: "error",
          title: "Informações do comprovante inválidas",
        })
      );
    }
  };

  static removeSpaces = (text: string) => text.replaceAll(" ", "");

  static formatInputPhone = (phone: string | number) => {
    if (!phone) return "";

    const cleanedPhone = this.removeSpaces(String(phone));

    if (cleanedPhone.length === 9) {
      return "(##) #####-####";
    } else {
      return "(##) ####-####";
    }
  };

  static getLastSubstring = (character: string, text: string) => {
    let newText = text;
    if (text && character) {
      let textParts = text.split(character);
      newText = textParts[textParts.length - 1];
    }
    return newText;
  };

  static findObjectInArray = (
    array: Array<object> = [],
    propertyName: string,
    searchValue: string | number
  ) => {
    return array.find((item) => item[propertyName] === searchValue) || null;
  };

  static decryptField = (content: string) => {
    const secretkey = REACT_APP_VIATRACKING_KEY_DECRYPT;
    const key = CryptoJS.enc.Utf8.parse(secretkey);
    const iv = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 16));

    try {
      let decrypted = CryptoJS.AES.decrypt(content, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch {
      return "";
    }
  };

  static copyToClipboard = (text): any => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        store.dispatch(
          openToast({
            severity: "success",
            title: "Texto copiado para a área de transferência",
          })
        );
      })
      .catch(() => {
        store.dispatch(
          openToast({
            severity: "error",
            title: "Erro ao copiar o texto",
          })
        );
      });
  };

  static getErrorMessagesFromApi = (response) => {
    const [message] = response.messages;
    return message?.text || "Erro inesperado, tente novamente!";
  };

  static escapeCharacterFromStringUrl = (
    value: string | Array<string>,
    character: string = "&"
  ): string | Array<string> => {
    switch (typeof value) {
      case "string":
        return value.includes(character) ? encodeURIComponent(value) : value;
      case "object":
        if (Array.isArray(value)) {
          return value.map((item) => {
            if (item.includes(character)) {
              return encodeURIComponent(item);
            } else {
              return item;
            }
          });
        }
        return "";
      default:
        return "";
    }
  };

  static validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj === "" || cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj))
      return false;

    const sizes = [12, 13];
    const dvs = [0, 0];

    sizes.forEach((size, index) => {
      let som = 0;
      let pos = size - 7;
      for (let i = size; i >= 1; i--) {
        som += cnpj.charAt(size - i) * pos--;
        if (pos < 2) pos = 9;
      }
      const result = som % 11 < 2 ? 0 : 11 - (som % 11);
      dvs[index] = result;
    });

    return (
      dvs[0] === Number(cnpj.charAt(12)) && dvs[1] === Number(cnpj.charAt(13))
    );
  };

  static transformFieldContent = (
    field: string | Array<string>,
    transformMethod: (content: string) => string
  ): string => {
    const isString = typeof field === "string";
    const isArray = Array.isArray(field);

    const applyTransformMethod = (content) =>
      content ? transformMethod(content) : "";

    let transformedContent = "";

    if (isArray) {
      transformedContent = field.map(applyTransformMethod).join(" ");
    } else if (isString) {
      transformedContent = applyTransformMethod(field);
    }
    return transformedContent.trim();
  };

  static removeEmptyParams = (params: any) => {
    const cleanedParams = {};
    for (const key in params) {
      if (
        params[key] !== "" &&
        params[key] !== null &&
        params[key] !== undefined &&
        params[key] !== "undefined" &&
        params[key] !== "null"
      ) {
        cleanedParams[key] = params[key];
      }
    }
    return cleanedParams;
  };

  /**
   * Limpa parâmetros de query string removendo valores falsy e arrays vazios.
   * Versão melhorada de removeEmptyParams que também remove arrays vazios.
   *
   * Remove: null, undefined, "", "null", "undefined", [] (arrays vazios)
   * Mantém: 0, false (podem ser valores válidos)
   *
   * TODO: Migrar gradualmente todas as telas para usar esta função no lugar de removeEmptyParams
   *
   * @param params - Objeto com parâmetros a serem limpos
   * @returns Objeto com apenas valores válidos
   */
  static cleanQueryParams = (params: any) => {
    const cleanedParams = {};
    for (const key in params) {
      const value = params[key];
      // Remove null, undefined, strings vazias, "undefined", "null" e arrays vazios
      // Mantém 0 e false pois podem ser valores válidos
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        value !== "undefined" &&
        value !== "null" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        cleanedParams[key] = value;
      }
    }
    return cleanedParams;
  };

  static formatPhoneNumber = (phone: string) => {
    if (!phone) return "";

    // Remove todos os caracteres não numéricos
    const cleanPhone = phone.replace(/\D/g, "");

    // Verifica se já tem máscara (contém parênteses, hífen ou espaço)
    const hasMask = /[()\-\s]/.test(phone);

    // Se já tem máscara, retorna o telefone original
    if (hasMask) {
      return phone;
    }

    // Formata o telefone baseado na quantidade de dígitos
    if (cleanPhone.length === 11) {
      // Celular com DDD: (XX) XXXXX-XXXX
      return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(
        2,
        7
      )}-${cleanPhone.slice(7)}`;
    } else if (cleanPhone.length === 10) {
      // Fixo com DDD: (XX) XXXX-XXXX
      return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(
        2,
        6
      )}-${cleanPhone.slice(6)}`;
    } else if (cleanPhone.length === 9) {
      // Celular sem DDD: XXXXX-XXXX
      return `${cleanPhone.slice(0, 5)}-${cleanPhone.slice(5)}`;
    } else if (cleanPhone.length === 8) {
      // Fixo sem DDD: XXXX-XXXX
      return `${cleanPhone.slice(0, 4)}-${cleanPhone.slice(4)}`;
    }

    // Se não se encaixar em nenhum formato, retorna o telefone limpo
    return cleanPhone;
  };
}

export default TrackingUtils;
